import { faBadgeCheck } from '@fortawesome/pro-solid-svg-icons';
import React, { useState } from 'react';
import {
  CaseCreationPreferenceOptions,
  EveCreateCaseModal,
  EveRoutes,
  useCaseCreationPreference,
} from '@ver-uds/e-verify';
import HomeButton from '../HomeButton';

export interface CreateCaseButtonProps {
  createCaseModal: boolean;
  isFederalContractor?: boolean;
}

const CreateCaseButton = ({ createCaseModal, isFederalContractor = false }: CreateCaseButtonProps): JSX.Element => {
  const [preference] = useCaseCreationPreference();
  const [isOpen, setIsOpen] = useState(false);
  const openModal = (): void => setIsOpen(true);

  const renderHomeButton = (link: string, action?: () => void) => {
    return <HomeButton link={link} svg={faBadgeCheck} linkText="Create New Case" action={action} />;
  };

  if (!createCaseModal) {
    return renderHomeButton(EveRoutes.CASES_NEW);
  }

  switch (preference) {
    case CaseCreationPreferenceOptions.CreateCaseUsingEVerify:
      return renderHomeButton(EveRoutes.CASES_NEW);
    case CaseCreationPreferenceOptions.CreateCaseUsingEVerifyPlus:
      return renderHomeButton(EveRoutes.CASES_DRAFT);
    case CaseCreationPreferenceOptions.CreateCasePromptUser:
    default:
      return (
        <>
          <EveCreateCaseModal
            open={isOpen}
            close={(): void => setIsOpen(false)}
            refresh={false}
            enableFederalContractorHelpText={isFederalContractor}
          />
          {renderHomeButton('', openModal)}
        </>
      );
  }
};

CreateCaseButton.defaultProps = {
  isFederalContractor: false,
};

export default CreateCaseButton;
